<template>
  <div style="width:100%;height:100%">
    <div ref="chart" style="width:100%;height:100%"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'Appointment',
  props: {
    chartName: {
      type: String,
      default: ''
    },
    SiginInfo: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      myChart: null,
      defaultData: [
        { value: 40, name: '设备签到' },
        { value: 38, name: '小程序签到' },
        { value: 32, name: '人工签到' },
      ]
    }
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.dispose();
    }
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    SiginInfo: {
      handler(newVal) {
        if (this.myChart) {
          this.updateChart(newVal);
        }
      },
      deep: true
    }
  },
  methods: {
    initChart() {
      if (!this.$refs.chart) return;

      if (this.myChart) {
        this.myChart.dispose();
      }

      this.myChart = echarts.init(this.$refs.chart);
      this.updateChart(this.SiginInfo.length > 0 ? this.SiginInfo : this.defaultData);
    },

    updateChart(data) {
      if (!this.myChart) return;

      // 处理数据：过滤掉值为0的项，并重新计算百分比
      let processedData = data.filter(item => item.value > 0);
      
      // 检查原始数据是否全部为0
      const allZero = data.every(item => item.value === 0);

      if (allZero) {
        // 如果所有数据都为0，使用原始数据（全部为0）
        processedData = [...data];
      } else if (processedData.length === 0) {
        // 如果没有大于0的数据，显示空图表
        processedData = [];
      } else if (processedData.length === 1) {
        // 如果只剩1个数据，确保它显示为完整的圆环（100%）
        processedData = [{
          ...processedData[0],
          value: 100
        }];
      } else if (processedData.length === 2) {
        // 如果剩2个数据，重新计算百分比使总和为100%
        const total = processedData[0].value + processedData[1].value;
        if (total > 0) {
          processedData = processedData.map(item => ({
            ...item,
            value: Math.round((item.value / total) * 100)
          }));
          // 确保总和为100%
          const sum = processedData[0].value + processedData[1].value;
          if (sum !== 100) {
            processedData[0].value = processedData[0].value + (100 - sum);
          }
        }
      }
      // 如果有3个数据，保持原样（已经是完整的圆环）

      const option = {
        title: {
          text: this.chartName,
          left: 'center',
          top: 10,
          textStyle: {
            color: '#333',
            fontSize: 14,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {d}%'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 0,
          top: 'modal',
          textStyle: {
            color: '#666'
          }
        },
        color: ['#297DEE', '#FFB322', '#FF3E50'],
        series: [
          {
            name: this.chartName,
            type: 'pie',
            radius: [20, 90],
            center: ['40%', '50%'],
            roseType: 'area',
            itemStyle: {
              borderRadius: 2,
              borderColor: '#fff',
              borderWidth: 0
            },
            label: {
              show: true,
              formatter: '{b}: {c}%'
            },
            labelLine: {
              length: 8,
              length2: 15
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 12,
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: processedData
          }
        ]
      };

      this.myChart.setOption(option);
    },

    handleResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    }
  }
}
</script>
